import {Utils} from 'components/shared';

var keyModifier = Utils.getKeyModifier();

var defaultKeymap = {
    ArrRequestDetail: {},
};

export default defaultKeymap;
